// extracted by mini-css-extract-plugin
module.exports = {"successModalWrapper":"styles_successModalWrapper__lc0ny","congratText":"styles_congratText__iarP5","successText":"styles_successText__4woCB"};
module.exports.__checksum = "3e8c32eb8ca3"